//
// crumblr.js -- cookie helper
//

function get_cookie(name) {
  const name_eq = `${name}=`;
  const matching_cookie = document.cookie.split(';')
    .map(c => c.trim())
    .find(c => c.indexOf(name_eq) === 0);

  return matching_cookie !== undefined ? matching_cookie.substring(name_eq.length) : null;
}

function set_cookie(name, value, expires_in_days_hence, path, domain) {
  let t = new Date();
  if (typeof expires_in_days_hence === 'number') {
    t.setMilliseconds((new Date()).getMilliseconds() + expires_in_days_hence * 1000 * 3600 * 24);
  }

  const parts = [
    `${name}=${value}`,
    expires_in_days_hence ? `; expires=${t.toUTCString()}` : '',
    path ? `; path=${path}` : `; path=/`,
    domain ? `; domain=${domain}` : '',
  ];

  document.cookie = parts.join('');
}

function delete_cookie(name, path, domain) {
  set_cookie(name, '', -1, path, domain);
}

export {
  get_cookie,
  set_cookie,
  delete_cookie,
};

